import * as React from "react";

import { ButtonToolbar } from "react-bootstrap";
import { connect } from "shared/src/stores/storeConnect";
import MenuItemList from "./MenuItemList";
import MenuItemLink from "./MenuItemLink";
import { CmsNavigationMenu } from "./CmsNavigationMenu";
import { NavigationMenu } from "../../../datatypes/NavigationMenu";
import { MenuItem } from "../../../datatypes/MenuItem";
import NavigationMenuStore from "../../../stores/NavigationMenuStore";
import SessionStore, { isTier12Customer } from "shared/src/stores/SessionStore";
import { StoreMenuItems } from "../mobileheader/MobileMenu";

type Props = {
    useExternalNavigation: boolean;
    cmsMenuRef: React.RefObject<CmsNavigationMenu>;
    miniShoppingCart: any;
    navigationMenu: NavigationMenu;
    customerStore: string | undefined;
    customerId: string | undefined;
    isCurrentCustomerFsdCustomer: boolean;
    isTier12Customer: boolean;
};

class NavigationMenuBar extends React.Component<Props> {
    renderNavigationMenuItem(item: MenuItem | undefined) {
        if (item) {
            if (item.relativeURL || item.absoluteURL) {
                return <MenuItemLink menuItemLink={item} key={item.id} />;
            } else {
                return <MenuItemList menuItemList={item} key={item.id} />;
            }
        }
        return null;
    }

    render() {
        const menuEntries = this.props.navigationMenu?.personal ?? [];
        const orders = menuEntries.find((element) => {
            return element.id === "orders";
        });
        const list = menuEntries.find((element) => {
            return element.id === "lists";
        });

        const shouldShowExternalNavigationComponent = this.props.useExternalNavigation;
        return shouldShowExternalNavigationComponent ? (
            <CmsNavigationMenu
                ref={this.props.cmsMenuRef}
                store={<StoreMenuItems isCurrentCustomerFsdCustomer={this.props.isCurrentCustomerFsdCustomer} />}
                miniShoppingCart={this.props.miniShoppingCart}
                list={this.props.isTier12Customer ? null : this.renderNavigationMenuItem(list)}
                orders={this.props.isTier12Customer ? null : this.renderNavigationMenuItem(orders)}
                storeId={this.props.customerStore}
                customerId={this.props.customerId}
            />
        ) : (
            <ButtonToolbar>
                <div className="navigationbar-left">
                    {(this.props.navigationMenu?.shop || []).map((item) => this.renderNavigationMenuItem(item))}
                </div>
                <div className="navigationbar-right">
                    {!this.props.isTier12Customer &&
                        (this.props.navigationMenu?.personal || []).map((item) => this.renderNavigationMenuItem(item))}
                    {this.props.miniShoppingCart}
                </div>
            </ButtonToolbar>
        );
    }
}

const wrapped = connect(
    {
        stores: [
            [
                NavigationMenuStore,
                (store: typeof NavigationMenuStore) => ({
                    navigationMenu: store.getNavigationMenu()?.navigationMenu ?? null
                })
            ],
            [
                SessionStore,
                (store: typeof SessionStore) => ({
                    customerStore: store.getState().customerStore,
                    customerId: store.getState().customerId,
                    isTier12Customer: isTier12Customer()
                })
            ]
        ]
    },
    NavigationMenuBar
);

export default wrapped;
